import React, {Component} from 'react';
import {Button, ControlLabel, FormControl, FormGroup} from 'react-bootstrap';
import ErrorMessageContainer from './ErrorMessageContainer';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import axios from 'axios';
import Utils from './Utils';
import DecimalHelpBlock from './DecimalHelpBlock';

require('moment/locale/el');

export default class ContractItemsHistoryEdit extends Component {
    constructor() {
        super();

        this.state = {
            history_id: 0,
            delivery_date: moment(),
            quantity: "",
            submit_disabled: false,
            validationErrors: []
        };

        this.handleDeliveryDateChange = this.handleDeliveryDateChange.bind(this);
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.historyId !== undefined && nextProps.historyId !== 0) {
            let url = "/contracts/ajax/manage_contracts/" + nextProps.contractId + "/items_history/" + nextProps.itemId + "/" + nextProps.historyId;
            axios
                .get(url)
                .then((response) => {
                    let delivery_date = moment();
                    let history = response.data;

                    if (history.delivery_date_formatted === null)
                        delivery_date = moment();
                    else if (history.delivery_date_formatted === "")
                        delivery_date = "";
                    else
                        delivery_date = moment(history.delivery_date_formatted, "DD/MM/YYYY");

                    this.setState({
                        history_id: history.id,
                        delivery_date: delivery_date,
                        quantity: history.quantity_comma
                    });
                });
        } else {
            this.setState({
                history_id: 0,
                delivery_date: moment(),
                quantity: ""
            });
        }
    }

    handleDeliveryDateChange(date) {
        this.setState({delivery_date: date});
    }

    handleQuantityChange(e) {
        let value = Utils.handleDecimals(e.target.value);
        this.setState({quantity: value});
    }

    submit() {
        if (!this.state.submit_disabled) {
            this.setState({
                validationErrors: [],
                submit_disabled: true
            }, () => {
                let url = "/contracts/ajax/manage_contracts/" + this.props.contractId + "/items_history/" + this.props.itemId + "/" + this.state.history_id;

                axios
                    .post(url, {
                        delivery_date: (this.state.delivery_date !== "" ? this.state.delivery_date.format("DD/MM/YYYY") : ""),
                        quantity: this.state.quantity
                    })
                    .then((response) => {
                        this.setState({
                            submit_disabled: false
                        }, () => {
                            this.props.submitCallback();
                        });
                    })
                    .catch((failure) => {
                        this.setState({
                            validationErrors: failure.response.data,
                            submit_disabled: false
                        });
                    });
            });
        }
    }

    render() {
        return (
            <div className={this.props.show ? "" : "hidden"}>
                <ErrorMessageContainer errors={this.state.validationErrors}/>

                <FormGroup controlId="delivery_date">
                    <ControlLabel>{window.__js_contracts.received_date}*</ControlLabel>
                    <DatePicker className="form-control"
                                name="delivery_date"
                                id="delivery_date"
                                selected={this.state.delivery_date}
                                onChange={this.handleDeliveryDateChange}
                                dateFormat="DD/MM/YYYY"
                                locale="el"/>
                </FormGroup>

                <FormGroup controlId="quantity">
                    <ControlLabel>{window.__js_contracts.quantity}*</ControlLabel>
                    <FormControl type="text"
                                 value={this.state.quantity}
                                 name="quantity"
                                 id="quantity"
                                 onChange={this.handleQuantityChange}/>
                    <DecimalHelpBlock/>
                </FormGroup>

                <FormGroup>
                    <Button onClick={this.submit}
                            bsStyle="primary"
                            disabled={this.state.submit_disabled}>
                        {this.state.history_id === 0 ? window.__js_general.add : window.__js_general.save}
                    </Button>
                </FormGroup>
            </div>
        );
    }
}